// "Production" enabled environment

export const environment = {
    wpa: true,
    production: true,
    hmr: false,
    remoteServiceBaseUrl: "https://posmaerapidev.maersoft.com.ar",
    appBaseUrl: "https://posmaerdev.maersoft.com.ar",
    localeMappings: [
        {
            "from": "es-AR",
            "to": "es"
        },
        {
            "from": "en-US",
            "to": "en"
        }
    ]
};
